import { AgentEffectCommands, CardProps } from "~/business";
import { AgentIcon, FactionType, ResourceType } from "../constant";
import { cardsDefRepository } from "./cardsDefRepository";

export const initCards = () => {
  const {
    BeneGesserit,
    Landsraad,
    City,
    SpiceTrade,
    Emperor,
    Fremen,
    SpacingGuild,
  } = AgentIcon;

  const {
    cause,
    beneGesseritUp,
    combatPoint,
    victoryPoint,
    draw,
    drawIntrigue,
    emperorUp,
    fremenUp,
    garnison,
    guildUp,
    influencePoints,
    or,
    and,
    signet,
    solaris,
    spice,
    trashCard,
    trashMe,
    trashMeOptional,
    water,
    fremenBond,
    hasPlayedBeneGesseritCard,
    chooseFactionChange,
    payResource,
    hasInfluenceLevel2,
    hasAlliance,
    drawBenegesseritInDiscsard,
    canRetreat,
    shouldRetreat,
    opponentsDiscard,
    opponentsLooseGarnisonTroop,
    influenceByPlayedFactionCard,
    doubleBaseSpice,
    opponentDiscardOrLooseTroop,
    playAnywhere,
    TSMFDiscount,
    blockActionSlot,
    discardCard,
    freighter,
    acquireTechTile,
    dreadnought,
    discardIntrigueCard,
    techNegociator,
    causeRaw,
    combatPointPerDreadnought,
    heighlinerDiscount,
    hasAgentOnFactionSlot,
    mayPlayAgain,
    combatPointForReavealedCard,
    canDeployToConflictTroop,
    hasNTechTile,
    isWithEnnemyAgent,
    ennemyRetreatForEachTroopDeployed,
  } = AgentEffectCommands;

  const chooseFactionUp = chooseFactionChange(1);

  const cardDefs: CardProps[] = [
    {
      cost: 0,
      name: "Dagger",
      factions: [],
      agentIcons: [Landsraad],
      playEffects: [],
      revealEffects: [combatPoint(1)],
    },
    {
      cost: 0,
      name: "Dune, the desert planet",
      factions: [],
      agentIcons: [SpiceTrade],
      playEffects: [],
      revealEffects: [influencePoints(1)],
    },
    {
      cost: 0,
      name: "Convincing argument",
      factions: [],
      agentIcons: [],
      playEffects: [],
      revealEffects: [influencePoints(2)],
    },
    {
      cost: 0,
      name: "Diplomacy",
      factions: [],
      agentIcons: [BeneGesserit, Fremen, Emperor, SpacingGuild],
      playEffects: [],
      revealEffects: [influencePoints(1)],
    },
    {
      cost: 0,
      name: "Seek allies",
      factions: [],
      agentIcons: [BeneGesserit, Fremen, Emperor, SpacingGuild],
      playEffects: [trashMe],
      revealEffects: [],
    },
    {
      cost: 0,
      name: "Signet ring",
      factions: [],
      agentIcons: [Landsraad, City, SpiceTrade],
      playEffects: [signet],
      revealEffects: [influencePoints(1)],
    },
    {
      cost: 0,
      name: "Reconnaissance",
      factions: [],
      agentIcons: [City],
      playEffects: [],
      revealEffects: [influencePoints(1)],
    },
    {
      cost: 0,
      name: "Foldspace",
      factions: [],
      agentIcons: Object.values(AgentIcon),
      playEffects: [draw, trashMe],
      revealEffects: [],
    },
    {
      cost: 9,
      name: "The spice must flow",
      factions: [],
      agentIcons: [],
      playEffects: [],
      buyEffects: [victoryPoint(1)],
      revealEffects: [spice(1)],
    },
    {
      cost: 2,
      name: "Arrakis liaison",
      factions: [FactionType.Fremen],
      agentIcons: [Landsraad, City],
      playEffects: [],
      revealEffects: [influencePoints(2)],
    },
    {
      cost: 5,
      name: "Stilgar",
      factions: [FactionType.Fremen],
      agentIcons: [Fremen, City, SpiceTrade],
      playEffects: [water(1)],
      revealEffects: [influencePoints(2), combatPoint(3)],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Liet Kynes",
      factions: [FactionType.Fremen, FactionType.Emperor],
      buyEffects: [emperorUp],
      agentIcons: [Fremen, City],
      playEffects: [],
      revealEffects: [
        influenceByPlayedFactionCard({
          amount: 2,
          faction: FactionType.Fremen,
        }),
      ],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Chani",
      factions: [FactionType.Fremen],
      buyEffects: [water(1)],
      agentIcons: [Fremen, City, SpiceTrade],
      playEffects: [],
      revealEffects: [canRetreat(20)],
      shopInstance: 1,
    },
    {
      cost: 3,
      name: "Crysknife",
      factions: [FactionType.Fremen],
      agentIcons: [Fremen, SpiceTrade],
      playEffects: [solaris(1)],
      revealEffects: [combatPoint(1), cause(fremenBond).effect(fremenUp)],
      shopInstance: 1,
    },
    {
      cost: 6,
      name: "Worm riders",
      factions: [FactionType.Fremen],
      agentIcons: [City, SpiceTrade],
      playEffects: [spice(2)],
      revealEffects: [
        cause(hasInfluenceLevel2(FactionType.Fremen)).effect(combatPoint(4)),
        cause(hasAlliance(FactionType.Fremen)).effect(combatPoint(2)),
      ],
      shopInstance: 2,
    },
    {
      cost: 4,
      name: "Fremen camp",
      factions: [FactionType.Fremen],
      agentIcons: [SpiceTrade],
      playEffects: [
        cause(payResource({ amount: 2, type: ResourceType.Spice })).effect(
          garnison(3)
        ),
      ],
      revealEffects: [influencePoints(2), combatPoint(1)],
      shopInstance: 2,
    },
    {
      cost: 4,
      name: "Fedaykin death commando",
      factions: [FactionType.Fremen],
      agentIcons: [City, SpiceTrade],
      playEffects: [trashCard],
      revealEffects: [
        influencePoints(1),
        cause(fremenBond).effect(combatPoint(3)),
      ],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Spice hunter",
      factions: [FactionType.Fremen],
      agentIcons: [Fremen, SpiceTrade],
      playEffects: [],
      revealEffects: [
        influencePoints(1),
        combatPoint(1),
        cause(fremenBond).effect(spice(1)),
      ],
      shopInstance: 2,
    },
    {
      cost: 4,
      name: "Guild ambassador",
      factions: [FactionType.Guild],
      agentIcons: [Landsraad],
      playEffects: [or([guildUp, spice(2)])],
      revealEffects: [
        cause(
          and([
            hasAlliance(FactionType.Guild),
            payResource({ amount: 3, type: ResourceType.Spice }),
          ])
        ).effect(victoryPoint(1)),
      ],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Smuggler's thopter",
      factions: [FactionType.Guild],
      agentIcons: [SpiceTrade],
      playEffects: [
        cause(hasInfluenceLevel2(FactionType.Guild)).effect(and([draw, draw])),
      ],
      revealEffects: [influencePoints(1), spice(1)],
      shopInstance: 2,
    },
    {
      cost: 3,
      name: "Space travel",
      factions: [FactionType.Guild],
      agentIcons: [SpacingGuild],
      playEffects: [draw],
      revealEffects: [influencePoints(2)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Spice smugglers",
      factions: [FactionType.Guild],
      agentIcons: [City],
      playEffects: [
        cause(payResource({ amount: 2, type: ResourceType.Spice })).effect(
          and([guildUp, solaris(3)])
        ),
      ],
      revealEffects: [influencePoints(1), combatPoint(1)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Guild administrator",
      factions: [FactionType.Guild],
      agentIcons: [SpacingGuild, SpiceTrade],
      playEffects: [trashCard],
      revealEffects: [influencePoints(1)],
      shopInstance: 2,
    },
    {
      cost: 8,
      name: "Kwisatz Haderach",
      factions: [FactionType.BeneGesserit],
      agentIcons: Object.values(AgentIcon),
      playEffects: [draw, playAnywhere],
      revealEffects: [],
      shopInstance: 1,
    },
    {
      cost: 7,
      name: "Lady Jessica",
      factions: [FactionType.BeneGesserit],
      agentIcons: [BeneGesserit, Landsraad, City, SpiceTrade],
      buyEffects: [chooseFactionUp],
      playEffects: [draw, draw],
      revealEffects: [influencePoints(3), combatPoint(1)],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Other memory",
      factions: [FactionType.BeneGesserit],
      agentIcons: [City, SpiceTrade],
      playEffects: [or([draw, drawBenegesseritInDiscsard])],
      revealEffects: [influencePoints(2)],
      shopInstance: 1,
    },
    {
      cost: 3,
      name: "Test of humanity",
      factions: [FactionType.BeneGesserit],
      agentIcons: [BeneGesserit, Landsraad, City],
      playEffects: [opponentDiscardOrLooseTroop],
      revealEffects: [influencePoints(2)],
      shopInstance: 1,
    },
    {
      cost: 3,
      name: "Gene manipulation",
      factions: [FactionType.BeneGesserit],
      agentIcons: [Landsraad, City],
      playEffects: [
        trashCard,
        cause(hasPlayedBeneGesseritCard).effect(spice(2)),
      ],
      revealEffects: [influencePoints(2)],
      shopInstance: 2,
    },
    {
      cost: 3,
      name: "Bene Gesserit initiate",
      factions: [FactionType.BeneGesserit],
      agentIcons: [Landsraad, City, SpiceTrade],
      playEffects: [draw],
      revealEffects: [influencePoints(1)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "The voice",
      factions: [FactionType.BeneGesserit],
      agentIcons: [City, SpiceTrade],
      playEffects: [blockActionSlot],
      revealEffects: [influencePoints(2)],
      shopInstance: 2,
    },
    {
      cost: 1,
      name: "Missionaria Protectiva",
      factions: [FactionType.BeneGesserit],
      agentIcons: [City],
      playEffects: [cause(hasPlayedBeneGesseritCard).effect(chooseFactionUp)],
      revealEffects: [influencePoints(1)],
      shopInstance: 2,
    },
    {
      cost: 3,
      name: "Bene Gesserit sister",
      factions: [FactionType.BeneGesserit],
      agentIcons: [BeneGesserit, Landsraad],
      playEffects: [],
      revealEffects: [or([influencePoints(2), combatPoint(2)])],
      shopInstance: 3,
    },
    {
      cost: 6,
      name: "Opulence",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor],
      playEffects: [solaris(3)],
      revealEffects: [
        influencePoints(1),
        cause(payResource({ amount: 6, type: ResourceType.Solaris })).effect(
          victoryPoint(1)
        ),
      ],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Firm grip",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor, Landsraad],
      playEffects: [
        cause(payResource({ amount: 2, type: ResourceType.Solaris })).effect(
          or([guildUp, beneGesseritUp, fremenUp])
        ),
      ],
      revealEffects: [
        cause(hasAlliance(FactionType.Emperor)).effect(influencePoints(4)),
      ],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Sardaukar legion",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor, Landsraad],
      playEffects: [garnison(2)],
      revealEffects: [influencePoints(1), canDeployToConflictTroop(3)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Imperial spy",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor],
      playEffects: [cause(trashMeOptional).effect(drawIntrigue)],
      revealEffects: [influencePoints(1), combatPoint(1)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Sardaukar infantry",
      factions: [FactionType.Emperor],
      agentIcons: [],
      playEffects: [],
      revealEffects: [influencePoints(1), combatPoint(2)],
      shopInstance: 2,
    },
    {
      cost: 8,
      name: "CHOAM directorship",
      factions: [],
      buyEffects: [emperorUp, guildUp, beneGesseritUp, fremenUp],
      agentIcons: [],
      playEffects: [],
      revealEffects: [solaris(3)],
      shopInstance: 1,
    },
    {
      cost: 6,
      name: "Gurney halleck",
      factions: [],
      agentIcons: [City],
      playEffects: [garnison(2), draw],
      revealEffects: [
        influencePoints(2),
        cause(payResource({ amount: 3, type: ResourceType.Solaris })).effect(
          and([garnison(2), canDeployToConflictTroop(2)])
        ),
      ],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Carryall",
      factions: [],
      agentIcons: [SpiceTrade],
      playEffects: [doubleBaseSpice],
      revealEffects: [influencePoints(1), spice(1)],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Peter de vries",
      factions: [],
      agentIcons: [Landsraad, City],
      playEffects: [drawIntrigue],
      revealEffects: [influencePoints(3), combatPoint(1)],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Duncan Idaho",
      factions: [],
      agentIcons: [City],
      playEffects: [
        cause(payResource({ amount: 1, type: ResourceType.Water })).effect(
          and([garnison(1), draw])
        ),
      ],
      revealEffects: [water(1), combatPoint(2)],
      shopInstance: 1,
    },
    {
      cost: 1,
      name: "Dr Yueh",
      factions: [],
      agentIcons: [City],
      playEffects: [draw],
      revealEffects: [influencePoints(1)],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Gun thopter",
      factions: [],
      agentIcons: [City, SpiceTrade],
      playEffects: [opponentsLooseGarnisonTroop(1)],
      revealEffects: [combatPoint(3), canDeployToConflictTroop(1)],
      shopInstance: 2,
    },
    {
      cost: 3,
      name: "Shifting allegiances",
      factions: [],
      agentIcons: [Landsraad, SpiceTrade],
      playEffects: [
        cause(
          and([
            payResource({ amount: 2, type: ResourceType.Spice }),
            chooseFactionChange(-1),
          ])
        ).effect(chooseFactionChange(2)),
      ],
      revealEffects: [influencePoints(2)],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Arrakis recruiter",
      factions: [],
      agentIcons: [City],
      playEffects: [garnison(1)],
      revealEffects: [influencePoints(1), combatPoint(1)],
      shopInstance: 2,
    },
    {
      cost: 1,
      name: "Scout",
      factions: [],
      agentIcons: [City, SpiceTrade],
      playEffects: [],
      revealEffects: [influencePoints(1), combatPoint(1), canRetreat(2)],
      shopInstance: 2,
    },
    // {
    //   cost: 1,
    //   name: "Assassination mission",
    //   factions: [],
    //   agentIcons: [],
    //   playEffects: [], // TODO when trashed, +4 solaris
    //   revealEffects: [solaris(1), combatPoint(1)],
    //   shopInstance: 2,
    // },
    {
      cost: 6,
      name: "Reverend mother Mohiam",
      factions: [FactionType.Emperor, FactionType.BeneGesserit],
      agentIcons: [Emperor, BeneGesserit],
      playEffects: [
        cause(hasPlayedBeneGesseritCard).effect(opponentsDiscard(2)),
      ],
      revealEffects: [influencePoints(2), spice(2)],
      shopInstance: 1,
    },
    {
      cost: 4,
      name: "Sietch reverend mother",
      factions: [FactionType.BeneGesserit, FactionType.Fremen],
      agentIcons: [BeneGesserit, Fremen],
      playEffects: [trashCard],
      revealEffects: [
        cause(fremenBond).effect(and([influencePoints(3), spice(3)])),
      ],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Thufir Hawat",
      factions: [],
      agentIcons: [
        Emperor,
        SpacingGuild,
        BeneGesserit,
        Fremen,
        City,
        SpiceTrade,
      ],
      playEffects: [draw],
      revealEffects: [influencePoints(1), drawIntrigue],
      shopInstance: 1,
    },
    {
      cost: 3,
      name: "Guild bankers",
      factions: [FactionType.Guild],
      agentIcons: [Emperor, SpacingGuild, Landsraad],
      playEffects: [],
      revealEffects: [TSMFDiscount(3)],
      shopInstance: 1,
    },
    {
      cost: 5,
      name: "Power play",
      factions: [],
      agentIcons: [Emperor, SpacingGuild, BeneGesserit, Fremen],
      playEffects: [trashMe, chooseFactionUp],
      revealEffects: [],
      shopInstance: 3,
    },
  ];

  const ixCardDefs: CardProps[] = [
    {
      cost: 5,
      name: "Appropriate",
      factions: [FactionType.Emperor],
      agentIcons: [Landsraad, SpiceTrade],
      playEffects: [
        cause(hasInfluenceLevel2(FactionType.Emperor)).effect(
          acquireTechTile({ mayBuyWithSolaris: true })
        ),
      ],
      buyEffects: [freighter],
      revealEffects: [influencePoints(2)],
    },
    {
      cost: 1,
      name: "Bounty Hunter",
      factions: [],
      agentIcons: [City],
      playEffects: [cause(isWithEnnemyAgent).effect(solaris(2))],
      buyEffects: [],
      revealEffects: [influencePoints(1), combatPoint(1)],
      hasInfiltration: true,
    },
    {
      cost: 1,
      name: "Choam Delegate",
      factions: [],
      agentIcons: [SpiceTrade],
      playEffects: [],
      buyEffects: [],
      revealEffects: [solaris(3)],
      hasUnload: true,
      hasInfiltration: true,
    },
    {
      cost: 2,
      name: "Court Intrigue",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor],
      playEffects: [cause(discardIntrigueCard).effect(drawIntrigue)],
      buyEffects: [],
      revealEffects: [influencePoints(1), combatPoint(1)],
      hasInfiltration: true,
    },
    {
      cost: 3,
      name: "Desert Ambush",
      factions: [FactionType.Fremen],
      agentIcons: [SpiceTrade],
      playEffects: [ennemyRetreatForEachTroopDeployed],
      buyEffects: [],
      revealEffects: [influencePoints(1), combatPoint(1)],
    },
    {
      cost: 5,
      name: "Embedded Agent",
      factions: [FactionType.BeneGesserit],
      agentIcons: [Landsraad],
      playEffects: [
        cause(hasPlayedBeneGesseritCard).effect(and([freighter, freighter])),
      ],
      buyEffects: [],
      revealEffects: [influencePoints(1), drawIntrigue],
      hasInfiltration: true,
    },
    {
      cost: 5,
      name: "Esmar Tuek",
      factions: [FactionType.Guild],
      agentIcons: [City, SpiceTrade],
      playEffects: [
        cause(payResource({ amount: 1, type: ResourceType.Spice })).effect(
          and([beneGesseritUp, draw])
        ),
      ],
      buyEffects: [],
      revealEffects: [spice(2), solaris(2)],
      hasUnload: true,
    },
    {
      cost: 2,
      name: "Freighter Fleet",
      factions: [],
      agentIcons: [SpiceTrade],
      playEffects: [],
      buyEffects: [],
      revealEffects: [freighter],
      hasUnload: true,
      shopInstance: 2,
    },
    {
      cost: 8,
      name: "Full-Scale Assault",
      factions: [FactionType.Emperor],
      agentIcons: [Emperor, City],
      playEffects: [garnison(2)],
      buyEffects: [dreadnought],
      revealEffects: [influencePoints(2), combatPointPerDreadnought(3)],
      shopInstance: 1,
    },
    {
      cost: 6,
      name: "Guild Accord",
      factions: [FactionType.Guild],
      agentIcons: [SpacingGuild],
      playEffects: [heighlinerDiscount(2)],
      buyEffects: [],
      revealEffects: [
        water(1),
        cause(hasInfluenceLevel2(FactionType.Guild)).effect(spice(3)),
      ],
      hasUnload: true,
      hasInfiltration: true,
    },
    {
      cost: 4,
      name: "Guild Chief Administrator",
      factions: [FactionType.Guild],
      agentIcons: [SpacingGuild, City, SpiceTrade],
      playEffects: [cause(discardCard).effect(trashCard)],
      buyEffects: [],
      revealEffects: [influencePoints(1), freighter],
    },
    {
      cost: 4,
      name: "Imperial Bashar",
      factions: [FactionType.Emperor],
      agentIcons: [City],
      playEffects: [or([garnison(1), trashCard])],
      revealEffects: [
        influencePoints(1),
        combatPoint(2),
        combatPointForReavealedCard(1),
      ],
      shopInstance: 1,
    },
    {
      cost: 3,
      name: "Imperial Shock Trooper",
      factions: [FactionType.Emperor],
      agentIcons: [],
      playEffects: [],
      revealEffects: [
        influencePoints(1),
        combatPoint(2),
        cause(hasAgentOnFactionSlot(FactionType.Emperor)).effect(
          combatPoint(3)
        ),
      ],
      shopInstance: 1,
    },
    {
      cost: 2,
      name: "In the Shadows",
      factions: [FactionType.BeneGesserit],
      agentIcons: [Landsraad, City],
      playEffects: [
        cause(hasInfluenceLevel2(FactionType.BeneGesserit)).effect(
          or([emperorUp, guildUp, fremenUp])
        ),
      ],
      revealEffects: [beneGesseritUp],
      hasUnload: true,
      shopInstance: 2,
    },
    {
      cost: 3,
      name: "Ix-Guild Compact",
      factions: [FactionType.Guild],
      agentIcons: [SpacingGuild],
      playEffects: [cause(and([discardCard, discardCard])).effect(dreadnought)],
      revealEffects: [techNegociator, techNegociator],
      hasUnload: true,
    },
    {
      cost: 5,
      name: "Ixian Engineer",
      factions: [],
      agentIcons: [SpiceTrade],
      playEffects: [acquireTechTile({})],
      revealEffects: [
        cause(and([hasNTechTile(3), trashMe])).effect(victoryPoint(1)),
      ],
      shopInstance: 2,
    },
    {
      cost: 2,
      name: "Jamis",
      factions: [FactionType.Fremen],
      agentIcons: [Fremen],
      playEffects: [trashCard],
      revealEffects: [influencePoints(1), combatPoint(2)],
      hasInfiltration: true,
    },
    {
      cost: 4,
      name: "Landing Rights",
      factions: [FactionType.Guild],
      agentIcons: [City],
      playEffects: [freighter],
      revealEffects: [influencePoints(2)],
      hasInfiltration: true,
    },
    {
      cost: 3,
      name: "Local Fence",
      factions: [],
      agentIcons: [City],
      playEffects: [
        or([
          causeRaw(payResource({ amount: 2, type: ResourceType.Spice })).effect(
            solaris(5)
          ),
          causeRaw(
            payResource({ amount: 5, type: ResourceType.Solaris })
          ).effect(spice(4)),
        ]),
      ],
      revealEffects: [influencePoints(2)],
    },
    {
      cost: 4,
      name: "Negotiated Withdrawal",
      factions: [],
      agentIcons: [Landsraad, City, SpiceTrade],
      buyEffects: [garnison(1)],
      playEffects: [],
      revealEffects: [
        influencePoints(2),
        cause(shouldRetreat(3)).effect(chooseFactionUp),
      ],
      shopInstance: 2,
    },
    {
      cost: 5,
      name: "Satellite Ban",
      factions: [FactionType.Guild, FactionType.Fremen],
      agentIcons: [Fremen, SpacingGuild],
      playEffects: [cause(discardCard).effect(and([spice(1), water(1)]))],
      revealEffects: [influencePoints(1), canRetreat(2)],
    },
    {
      cost: 3,
      name: "Sayyadina",
      factions: [FactionType.BeneGesserit, FactionType.Fremen],
      agentIcons: [Fremen, BeneGesserit],
      playEffects: [
        cause(payResource({ amount: 3, type: ResourceType.Water })).effect(
          victoryPoint(1)
        ),
      ],
      revealEffects: [cause(fremenBond).effect(influencePoints(3))],
    },
    {
      cost: 7,
      name: "Shai-Hulud",
      factions: [FactionType.Fremen],
      agentIcons: [SpiceTrade],
      buyEffects: [trashCard],
      playEffects: [cause(trashCard).effect(garnison(2))],
      revealEffects: [cause(fremenBond).effect(combatPoint(5))],
    },
    {
      cost: 4,
      name: "Spice Trader",
      factions: [FactionType.Fremen],
      agentIcons: [City, SpiceTrade],
      playEffects: [
        cause(
          and([hasInfluenceLevel2(FactionType.Fremen), discardCard])
        ).effect(spice(2)),
      ],
      revealEffects: [influencePoints(2), combatPoint(1)],
    },
    {
      cost: 6,
      name: "Treachery",
      factions: [],
      agentIcons: [Fremen, BeneGesserit, SpacingGuild, Emperor],
      playEffects: [trashMe, chooseFactionUp],
      revealEffects: [garnison(2), canDeployToConflictTroop(2)],
      shopInstance: 2,
      hasUnload: true,
    },
    {
      cost: 3,
      name: "Truthsayer",
      factions: [FactionType.Emperor, FactionType.BeneGesserit],
      agentIcons: [BeneGesserit, Emperor, Landsraad],
      playEffects: [cause(discardCard).effect(draw)],
      revealEffects: [influencePoints(1), combatPoint(1)],
      shopInstance: 2,
    },
    {
      cost: 1,
      name: "Water Peddler",
      factions: [],
      agentIcons: [],
      buyEffects: [water(1)],
      playEffects: [],
      revealEffects: [influencePoints(1)],
      hasUnload: true,
    },
    {
      cost: 4,
      name: "Web of Power",
      factions: [FactionType.BeneGesserit],
      agentIcons: [BeneGesserit],
      playEffects: [
        cause(hasInfluenceLevel2(FactionType.Emperor)).effect(solaris(2)),
        cause(hasInfluenceLevel2(FactionType.Guild)).effect(draw),
        cause(hasInfluenceLevel2(FactionType.Fremen)).effect(water(1)),
      ],
      revealEffects: [influencePoints(1), chooseFactionUp],
      hasInfiltration: true,
    },
    {
      cost: 3,
      name: "Weirding Way",
      factions: [FactionType.BeneGesserit],
      agentIcons: [City, SpiceTrade],
      playEffects: [mayPlayAgain],
      revealEffects: [influencePoints(1), combatPoint(2)],
    },
  ];

  const filledIxCards: CardProps[] = ixCardDefs.map((card) => ({
    ...card,
    shopInstance: card.shopInstance ?? 1,
    extension: "Ix",
  }));

  const cardDefEntities = [...cardDefs, ...filledIxCards].map((cardDef) => ({
    ...cardDef,
    id: cardDef.name,
  }));

  cardsDefRepository.addAll(cardDefEntities);
  console.debug("init cards");
};
